<template>
  <div class="withdrawStep">
    <div class="withdrawStep-top">
      <div class="iconfont iconzuojiantou jian" @click="goback"></div>
      <div>提现</div>
      <div></div>
    </div>
    
    <div class="withdrawStep-step">
      <van-steps direction="vertical" :active="1" active-color="#0681FD">
          <van-step>
            <h3>发起提现申请</h3>
          </van-step>
          <van-step>
            <h3>银行处理中</h3>
            <p>预计2小时内到账</p>
          </van-step>
          <van-step>
            <h3>到账成功</h3>
          </van-step>
    </van-steps>
    </div>
    <div class="withdrawStep-line">
      <div class="line"></div>
    </div>

    <div class="withdrawStep-message">
      <div class="step-left">
        <div class="mar-10">提现金额</div>
        <div>到账银行卡</div>
      </div>
      <div class="step-right">
        <div class="mar-10">{{amount}}</div>
        <div><span>{{bankName}}</span> <span>{{bankNo.slice(-4)}}</span></div>
      </div>
    </div>
    <div class="withdrawStep-finish" @click="onFinish">
      <div class="finish">完成</div>
    </div>
  </div>
</template>
<script>
import http from "../../../api/index.js";
import config from "../../../utils/config";
export default {
  data(){
    return{
      amount:"",
      bankName:"",
      bankNo:""
    }
  } ,
  mounted(){
    const url = new URL(location.href);
    this.amount = url.searchParams.get('amount');
    this.myWalletDedail()
  },
  methods:{
    goback(){
      this.$router.go(-1)
    },
    myWalletDedail(){
      http.post(config.myWallet).then(({code,data,message})=>{ 
        console.log(data)
        if(code===0){
          this.bankName=data.bindCardDetail[0].bankName;
          this.bankNo=data.bindCardDetail[0].bankNo;
        }else{
          this.$toast.fail(message)
          // this.$router.push({path:"/noLogin"})
        }
      })
    },
    onFinish(){
      this.$router.push({path:"/myWallet"})
    }
  }
}
</script>
<style scoped lang="less">
.withdrawStep{
  text-align: left;
  .withdrawStep-top{
    padding: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 35px;
    .jian{
      font-size: 35px;
    }
  }
  .withdrawStep-step{

  }
  .withdrawStep-line{
    width: 100%;
    display: flex;
    justify-content: center;
    .line{
      width: 90%;
      height: 1px;
      background: #888888;
    }   
  }
  .withdrawStep-message{
    padding: 40px;
    display: flex;
    justify-content: space-between;
    align-items: center ;
    .step-left{
      color: #A0A1A3;
      .mar-10{
        margin-bottom: 10px;
      }
    }
    .step-right{
      text-align: right;
      color: #000000;
      font-weight: 500;
    }
  }
  .withdrawStep-finish{
    width: 100%;
    display: flex;
    justify-content: center;
    position: fixed;
    bottom: 0;
    .finish{
      width: 90%;
      height: 90px;
      line-height: 90px;
      background: #0681FD;
      text-align: center;
      color: #ffffff;
      font-size: 34px;
      border-radius: 45px;
    }
  }

}
</style>


// WEBPACK FOOTER //
// src/pages/wallet/withdrawStep/index.vue